var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgFilter = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 15,
    height: 15,
    viewBox: "0 0 15 15",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_239_658)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M14.936 0.425776C14.8152 0.14927 14.6062 0.010998 14.308 0.010849H0.691695C0.393876 0.010849 0.184587 0.14927 0.0640141 0.425776C-0.0564846 0.716441 -0.00689161 0.964816 0.213017 1.17042L5.45762 6.41487V11.5849C5.45762 11.7695 5.52502 11.9289 5.65971 12.0638L8.38286 14.7869C8.51062 14.9215 8.67013 14.9891 8.86168 14.9891C8.94671 14.9891 9.03532 14.9713 9.12753 14.9358C9.40423 14.8152 9.54261 14.6061 9.54261 14.3082V6.4149L14.787 1.17045C15.007 0.964853 15.0565 0.716552 14.936 0.425776Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_239_658"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 15,
    height: 15,
    fill: "white"
  })))));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgFilter);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/filter.eb8881f8a6d6faab55f0a794ecb15dfd.svg";